import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ListingTabFilter } from '../interfaces/listing-tab-filter';
import { ListingSearchFilter } from '../interfaces/listing-search-filter';

@Component({
  exportAs: 'mandaeDashboardListing',
  selector: 'mandae-dashboard-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss']
})
export class ListingComponent implements OnInit {

  /**
   * O título a ser exibido na página
   *
   * É exibido dentro de uma tag H1
   */
  @Input()
  public heading: string;

  @Input()
  public showPaginator = true;

  /**
   * Filtros por abas
   */
  @Input()
  public get tabFilters(): ListingTabFilter[] {
    return this._tabFilters || [];
  }
  public set tabFilters(value: ListingTabFilter[]) {
    this._tabFilters = value;

    if (!value || value.length === 0) {
      this.currentTabFilter = '';
      return;
    }

    if (!value.map(v => v.value).includes(this.currentTabFilter)) {
      this.currentTabFilter = value[0].value;
    }
  }
  private _tabFilters: ListingTabFilter[] = null;

  /**
   * Filtro de aba selecionado no momento
   */
  @Input()
  public get currentTabFilter() {
    return this._currentTabFilter;
  }
  public set currentTabFilter(value: string) {
    if (this._currentTabFilter !== value) {
      this.currentTabFilterChange.emit(value);
    }

    this._currentTabFilter = value;
  }
  private _currentTabFilter = '';

  /**
   * Emissor de eventos que dispara quando uma nova aba é selecionada
   */
  @Output()
  public currentTabFilterChange = new EventEmitter<string>();

  /**
   * Flag de estado de carregamento de dados
   */
  @Input()
  public loading = false;

  /**
   * Total de páginas da tabela
   */
  @Input()
  public pages = 1;

  /**
   * Página atual da tabela
   */
  @Input()
  public get currentPage() {
    return this._currentPage;
  }
  public set currentPage(value: number) {
    if (this._currentPage !== value) {
      this.currentPageChange.emit(value);
    }

    this._currentPage = value;
  }
  private _currentPage = 1;

  /**
   * Quantidade de registros a serem exibidos por página
   */
  public get currentLimit() {
    return this._currentLimit;
  }
  public set currentLimit(value: number) {
    if (this._currentLimit !== value) {
      this.currentLimitChange.emit(value);
    }

    this._currentLimit = value;
  }
  private _currentLimit = 10;

  /**
   * Filtros a serem disponibilizados
   */
  @Input()
  public searchFilter: ListingSearchFilter[] = [];

  /**
   * Emissor de eventos que é disparado quando o usuário efetuar uma busca nos filtros
   */
  @Output() search = new EventEmitter<any>(true);

  /**
   * Emissor de eventos que é disparado quando o usuário alterar o limite de registros por página
   */
  @Output()
  public currentLimitChange = new EventEmitter<number>();

  /**
   * Emissor de eventos que é disparado quando o usuário alterar a página
   */
  @Output()
  public currentPageChange = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {
  }

  applyTabFilter(filter: ListingTabFilter) {
    this.currentTabFilter = filter.value;
  }

}
